import { TApiArgs, TApiKeysByNamespace, useAPI } from '@/services';
import { useRegister } from './useRegister';

export const useRegisterApi = <
  Key extends TApiKeysByNamespace<'register'>,
  IsMutation extends boolean,
  IsInfinite extends boolean,
>(
  key: Key,
  args: Omit<
    TApiArgs<'register', Key, IsMutation, IsInfinite>,
    'session' | 'context'
  >
) => {
  const { handleRegisterError } = useRegister();
  const Api = useAPI(['register', key], {
    ...args,
    rejectInterceptor: (error) => {
      handleRegisterError(error);
      return Promise.reject(error);
    },
    axiosRequestConfig: {
      analyticError: 'REGISTER_ERROR',
      ...args?.axiosRequestConfig,
    },
  });

  return Api;
};
